import { Spinner } from '@/components/Spinner';

import { ENROLMENT_COPY } from '../copy';
import { EnrolmentHeading } from './EnrolmentHeading';
import { EnrolmentShell } from './EnrolmentShell';

/**
 * Frame *06 · Connecting* — the six digits are with the server and the staffer waits [AC-7].
 *
 * ⭐ **The frame's content is `Heading` + `Spinner`, and nothing else** — read from the node tree, not from
 * the picture: ⛔ no cancel, no retry, no timeout affordance. That is why a failed or slow connect has no
 * screen to attach one to, and ⭐ **the Operator ruled on 2026-09-16 that it does not get one**: the device
 * returns to the pad and says *"We are having some issues. Try again later."* in the inline error frames 03
 * and 04 draw [`RULED_COPY.havingIssues`; decision 0262]. ⛔ Nothing new is drawn here.
 *
 * `aria-busy` with a polite live region, so the wait is announced once rather than being a silent pause for
 * anyone not watching the spinner.
 */
export function ConnectingScreen() {
  return (
    <EnrolmentShell>
      <div
        aria-busy="true"
        aria-live="polite"
        className="flex w-full flex-col items-center gap-6 pb-8 pt-2"
      >
        <EnrolmentHeading
          body={ENROLMENT_COPY.connectingBody}
          eyebrow={ENROLMENT_COPY.connectingEyebrow}
          heading={ENROLMENT_COPY.connectingHeading}
        />
        <Spinner />
      </div>
    </EnrolmentShell>
  );
}
